window.addEventListener('load', () => {
    const scrollFaders = document.querySelectorAll('.scroll-fader');
    if (scrollFaders.length) {
        let frameRateTarget = 24;  // Initially set for 30fps
        let disableEffect = false;
        let throttledUpdateScrollFaders;

        const updateThrottleRate = () => {
            throttledUpdateScrollFaders = _throttle(updateScrollFaders, frameRateTarget);
        };

        const updateFrameRateTarget = _debounce(function() {
            if (window.matchMedia('(max-width: 767px)').matches) {
                disableEffect = true;
            } else if (window.matchMedia('(min-width:768px) and (max-width: 1023px)').matches) {
                frameRateTarget = 24; // Throttle to 30fps on mobile/tablet
                disableEffect = false;
            } else {
                frameRateTarget = 12; // Throttle to 60fps on desktop
                disableEffect = false;
            }
            updateThrottleRate(); // Update the throttle rate whenever frameRateTarget changes
            updateScrollFaders(); // Update faders after changing settings
        }, 200);

        const updateScrollFaders = () => {
            scrollFaders.forEach(scrollFader => {
                let startEffectPos = scrollFader.getBoundingClientRect().top + window.scrollY;
                let endEffectPos = startEffectPos + scrollFader.offsetHeight;
                updateScrollEffect(scrollFader, startEffectPos, endEffectPos);
            });
        };

        const updateScrollEffect = (scrollFader, start, end) => {
            if (disableEffect) {
                scrollFader.style.transform = 'translateY(0)';
                scrollFader.style.filter = 'blur(0)';
                scrollFader.style.opacity = 1;
            } else {
                const scrollPosition = window.scrollY;
                if (scrollPosition >= start && scrollPosition <= end) {
                    const percentage = (scrollPosition - start) / (end - start);
                    const parallaxValue = (scrollPosition - start) * 0.3 + 'px';
                    const blurValue = 20 * percentage + 'px';
                    const opacityValue = 1 - percentage;
                    scrollFader.style.transform = `translateY(${parallaxValue})`;
                    scrollFader.style.filter = `blur(${blurValue})`;
                    scrollFader.style.opacity = opacityValue;
                } else if (scrollPosition < start) {
                    scrollFader.style.transform = 'translateY(0)';
                    scrollFader.style.filter = 'blur(0)';
                    scrollFader.style.opacity = 1;
                } else if (scrollPosition > end) {
                    scrollFader.style.transform = `translateY(${(end - start) * 0.3}px)`;
                    scrollFader.style.filter = 'blur(20px)';
                    scrollFader.style.opacity = 0;
                }
            }
        };

        // Initialize throttle function and event listeners
        updateThrottleRate();
        window.addEventListener('resize', () => {
            updateFrameRateTarget();
        });

        window.addEventListener('scroll', throttledUpdateScrollFaders);

        // Initial setup
        updateFrameRateTarget();
        updateScrollFaders();
    }
});
